export const SIZE = 48;
export const CENTER = SIZE / 2;
export const DOT_RADIUS = 4;
